<ion-header>
  <ion-navbar>
    <ion-title style="text-align:center">
      Ionic Savings
    </ion-title>
  </ion-navbar>
</ion-header>

<ion-content>
  <ion-row style="background: #4BB56D;color: white;">
    <ion-col col-10>
      <div style="background: #4BB56D;margin-top: 2%;font-size: 2.2rem;text-align: center;margin-left: 10%;">
        {{headerTitle}}
      </div>
    </ion-col>
    <ion-col col-2>
    <img src="assets/savingsimg/ic_close_white.png" (click)="dismiss()" height="36px" width="36px" 
    style="background: transparent;margin-left: 15%;">
    <!-- <ion-buttons end clear> <button (click)="dismiss()" style="background: transparent;">
          <img src="assets/savingsimg/ic_close_white.png" (click)="dismiss()" height="36px" width="36px">
        </button> </ion-buttons> -->
    </ion-col>
  </ion-row>
  <p style="padding: 1% 5%;"><b>
      How to redeem this deal</b></p>
  <p text-wrap style="padding: 1% 5%;">{{dealDetail.RedemptionText}}</p>
  <div *ngIf="shouldShowCard">
    <img src="assets/savingsimg/img_aaa_member_card.png">
    <p style="text-align:left;" style="padding: 0% 5%;"><b>
        Closest Location</b></p>
    <ion-row>
      <ion-col col-8>
        <p style="padding: 0% 5%;">{{nearStoreAddressText}}</p>
      </ion-col>
      <ion-col col-3>
        <p>{{nearStoreDistanceText}}</p>
      </ion-col>
    </ion-row>
  </div>

  <a [href]="formattedRedemptionLink" *ngIf="dealDetail.RedemptionLink">
    <button ion-button *ngIf="dealDetail.RedemptionLink" width="60%" 
    style="margin: 0% 25%;background-color: #047DA5;" [disabled]= "formattedRedemptionLink==''? true : false"  >
      <img src="assets/savingsimg/ic_detail_card_white.png" height="24px" width="24px" style="margin: 0 5px 0 0 ;">
      <b>View deal online</b>
    </button>
  </a>
  <a [href]="'tel:' + dealDetail.RedemptionPhone">
    <button ion-button color="ask" *ngIf="dealDetail.RedemptionPhone" width="60%" 
    style="margin: 0% 25%;background-color: #047DA5;padding-right: 10%;padding-left: 5%;">
      <img src="assets/savingsimg/ic_detail_phone_white.png" height="24px" width="24px" style="margin: 0 5px 0 0 ;">
      <b>{{dealDetail.RedemptionPhone}}</b>
    </button>
  </a>

</ion-content>